import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    FormErrorMessage,
    Input,
    Textarea
} from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import Select from 'react-select';
import * as Yup from 'yup';
import { fetchWrapper } from '../../helpers';
import { toast } from 'react-toastify';
import API from '../../helpers/axiosInstance';
import { getChannelLabel } from '../../utils/channels';

const validationSchema = Yup.object({
    phone: Yup.string()
    .matches(/^[0-9+\-\s()]+$/, 'Phone number can only contain numbers and special characters')
    .required('Phone number is required'),
    // parser: Yup.string().required('Parser is required'),
    message: Yup.string().required('Message is required'),
    // preferredChannel: Yup.string().required('Preferred channel is required'),
});

const ParserApi = () => {
    const [templateOptions, setTemplateOptions] = useState([]);
    const [channelOptions, setChannelOptions] = useState([]);
    const [senderIdOptions, setSenderIdOptions] = useState([]);
    const [parser, setParser] = useState({});
    const [loading, setLoading] = useState(false);

    // Kept in memory only — never localStorage, so the key isn't readable by any
    // other script/tab or left behind after the page closes.
    const [apiKey, setApiKey] = useState('');

    const TemplateList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/template-parser/list`;
            const data = await fetchWrapper.get(url);
            const transformed = data.data.map((item) => ({
                label: item?.TemplateMessage?.name,
                value: item?.parser_id,
                ...item,
            }));
            setTemplateOptions(transformed);
        } catch (error) {
            console.error('Error fetching templates:', error);
            toast('Error fetching templates', { type: 'error' });
        }
    };

    const ChannelList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/channel/list`;
            const data = await fetchWrapper.get(url);
            let transformedData = data.data.map((item) => ({
                label: getChannelLabel(item?.name),
                value: item?.name
            }));
            setChannelOptions([...transformedData, { label: "Smart Routing", value: "smart" }, { label: "Custom Routing", value: "custom" }]);
        } catch (error) {
            console.error('Error fetching channels:', error);
        }
    };

    const SenderIdList = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/channel/sms-list`;
            const data = await fetchWrapper.get(url);
            const transformedData = (data.data || []).map((item) => ({
                label: item?.account_name,
                value: item?.id
            }));
            setSenderIdOptions(transformedData);
        } catch (error) {
            console.error('Error fetching sender IDs:', error);
        }
    };

    useEffect(() => {
        TemplateList();
        ChannelList();
        SenderIdList();
        APIKEYGET();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
        const payload_without_custom = {
            to: values.phone,
            text: values.message,
            from:"1234567890",
            sender_id: values.senderId,

            // parser_id: values.parser,
            // payload_type: "text",
            // trans_type: parser?.TemplateMessage?.MessageTemplateType?.message_type_id,
            // preferred_channel: values.preferredChannel
        };
        const payload_with_custom = {
            to: values.phone,
            text: values.message,
            from:"1234567890",
            sender_id: values.senderId,
            // parser_id: values.parser,
            // payload_type: "text",
            // trans_type: parser?.TemplateMessage?.MessageTemplateType?.message_type_id,
            // preferred_channel: values.preferredChannel
        };

        const payload = (values.preferredChannel === "custom" || values.preferredChannel === 'smart') ? payload_with_custom : payload_without_custom;

        try {
            setLoading(true);
            let url = `${process.env.REACT_APP_SEND_API_URL}/v2/message`;
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey,
                    'host': "xnotify.ai"
                },
                data: payload
            };
            await API.post(url, payload, config);

            toast('Message has been sent', { type: 'success' });
          
        } catch (error) {
            toast(error.message || 'Failed to send message', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };
    const APIKEYGET = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}/customer/get-key?key_type=api_key`;
            const data = await fetchWrapper.get(url);
            setApiKey(data?.key || '');
        } catch (error) {
            console.error('Error fetching API key:', error);
        }
    };
    return (
        <div className='sms_body_section'>
            <Formik
                initialValues={{
                    phone: '',
                    parser: '',
                    message: '',
                    preferredChannel: '',
                    senderId: '',
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ isSubmitting, setFieldValue, values, errors, touched }) => (
                    <Form>
                        <Box style={{ width: "100%" }}>
                           
                            {/* Phone Number */}
                            <Field name="phone">
                                {({ field, form }) => (
                                    <FormControl isInvalid={form.errors.phone && form.touched.phone} mb={4} isRequired>
                                        <FormLabel>Phone Number</FormLabel>
                                        <Input {...field} placeholder="Enter phone number" />
                                        <FormErrorMessage>{form.errors.phone}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            {/* Sender ID Dropdown (react-select) */}
                            <Field name="senderId">
                                {({ form }) => (
                                    <FormControl isInvalid={form.errors.senderId && form.touched.senderId} mb={4}>
                                        <FormLabel>Sender ID</FormLabel>
                                        <Select
                                            options={senderIdOptions}
                                            value={senderIdOptions.find(option => option.value === values.senderId) || null}
                                            onChange={(option) => setFieldValue('senderId', option ? option.value : '')}
                                            placeholder="Select Sender ID"
                                            isClearable
                                        />
                                        <FormErrorMessage>{form.errors.senderId}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            {/* Parser Dropdown (react-select) */}
                            {/* <Field name="parser">
                                {({ form }) => (
                                    <FormControl isInvalid={form.errors.parser && form.touched.parser} mb={4} isRequired>
                                        <FormLabel>Parser</FormLabel>
                                        <Select
                                            options={templateOptions}
                                            value={templateOptions.find(option => option.value === values.parser)}
                                            onChange={(option) => {
                                                setFieldValue('parser', option.value);
                                                setFieldValue('message', option.message);
                                                setParser(option) // auto-fill message
                                            }}
                                            placeholder="Select Template"
                                        />
                                        <FormErrorMessage>{form.errors.parser}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field> */}

                           

                            {/* Message Textarea - FIXED with {...field} */}
                            <Field name="message">
                                {({ field, form }) => (
                                    <FormControl isInvalid={form.errors.message && form.touched.message} mb={4} isRequired>
                                        <FormLabel>Message</FormLabel>
                                        <Textarea {...field} placeholder="Enter message" rows={5} />
                                        <FormErrorMessage>{form.errors.message}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            {/* Preferred Channel (react-select) */}
                            {/* <Field name="preferredChannel">
                                {({ form }) => (
                                    <FormControl isInvalid={form.errors.preferredChannel && form.touched.preferredChannel} mb={4} isRequired>
                                        <FormLabel>Preferred Channel</FormLabel>
                                        <Select
                                            options={channelOptions}
                                            value={channelOptions.find(option => option.value === values.preferredChannel)}
                                            onChange={(option) => setFieldValue('preferredChannel', option.value)}
                                            placeholder="Select Channel"
                                        />
                                        <FormErrorMessage>{form.errors.preferredChannel}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field> */}

                            {/* Submit Button */}
                            <Button
                                 py="10px"
                                 px="25px"
                                 color="white" 
                                 background={"var(--brand-primary)"}
                                 fontSize="14px"
                                 fontWeight="500"
                                 fontFamily="'Lato', sans-serif"
                                 mb={4}
                                 style={{ width: "100%" }}
                                 type="submit"
                                isLoading={isSubmitting || loading}
                                mt={4}
                            >
                                Send Test Message
                            </Button>
                        </Box>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default ParserApi;